export const name = "BOOL";
export const summary = `Converts a JSON boolean to a SQL \`BOOL\` value.`;
export const reference = `
## BOOL

Converts a JSON boolean to a SQL \`BOOL\` value.

\`\`\`
BOOL(json_expr)
\`\`\`

### Description

Converts a JSON boolean to a SQL \`BOOL\` value.

Arguments:

- \`json_expr\`: JSON. For example:


### Return type

\`BOOL\`


### Examples



\`\`\`
SELECT BOOL(JSON 'true') AS vacancy;

/*---------*
 | vacancy |
 +---------+
 | true |
 *---------*/
\`\`\`



\`\`\`
SELECT BOOL(JSON_QUERY(JSON '{"hotel class": "5-star", "vacancy": true}', "$.vacancy")) AS vacancy;

/*---------*
 | vacancy |
 +---------+
 | true |
 *---------*/
\`\`\`

The following examples show how invalid requests are handled:



\`\`\`
-- An error is thrown if JSON isn't of type bool.
SELECT BOOL(JSON '123') AS result; -- Throws an error
SELECT BOOL(JSON 'null') AS result; -- Throws an error
SELECT SAFE.BOOL(JSON '123') AS result; -- Returns a SQL NULL
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/json_functions
`;
